import { BrowserModule, HammerModule } from "@angular/platform-browser";
import { Router, RouteReuseStrategy } from "@angular/router";

import {
	ActionStackEffect,
	AdriEffect,
	AlertAyModule,
	AlertParamEnCoursModule,
	AlertService,
	AnalyseEffect,
	AntecedentEffect,
	ApplicationEffect,
	AppState,
	AuthEffect,
	CabinetEffect,
	CaisseEffect,
	CampagneMyinfiAyEffect,
	CampagneMyinfiCallbackAyEffect,
	CentresSesamEffect,
	ClientEffects,
	CommandMobileEffect,
	ConsentementHdsEffect,
	ConstanteVitaleEffect,
	CustomLoadingAyService,
	DateInterceptor,
	DiagnosticStsEffect,
	DiagrammeSoinsCategorieEffect,
	DiagrammeSoinsCategoriePersoEffect,
	DiagrammeSoinsEffect,
	DiagrammeSoinsValeurEffect,
	DispatchatorEffect,
	DocumentOcrEffect,
	DocumentPatientEffect,
	ENTENTE_DIALOG_TOKEN,
	EntenteEffect,
	FacturationEffect,
	FacturationModule,
	FactureEffect,
	FeaturesModule,
	FichierEffect,
	FiltreEffect,
	HostEffect,
	IdelEffect,
	IdelExecutantEffect,
	IdelRemplacantEffect,
	IdelRemplacantModule,
	LaboratoireEffect,
	LoggerEffect,
	LotEffect,
	metaReducers,
	MobileAbsencePatientEffect,
	MobileAntecedentEffect,
	MobileDmpEffect,
	MobileDmpToDoFromMobileEffect,
	MobileDocumentPatientEffect,
	MobileFactureEffect,
	MobileIdeeEffect,
	MobileJourFeriePersoEffect,
	MobileLotEffect,
	MobileMutuelleEffect,
	MobileOrdonnanceEffect,
	MobilePatientEffect,
	MobilePlanningEffect,
	MobilePlanningMyInfiEffect,
	MobilePraticienEffect,
	MobilePreferenceEffect,
	MobileRdvMyInfiEffect,
	MobileRdvPersoEffect,
	MobileReglementEffect,
	MobileServiceCbaEffect,
	MobileServiceClientEffect,
	MUTUELLE_ALERT_SERVICE_TOKEN,
	MutuelleEffect,
	NavigationEffect,
	NomenclatureEffect,
	NotificationPsEffect,
	OrdonnanceBrouillonEffect,
	OrdonnanceEffect,
	OrdonnancePartielleEffect,
	OrdonnanceScorEffect,
	ParametresEffect,
	PATIENT_MODAL_SERVICE_TOKEN,
	PatientEffect,
	PersistentStoreEffect,
	PlanningEffect,
	PlanningMyInfiEffect,
	PraticienEffect,
	PrelevementEffect,
	PrelevementResultatEffect,
	ProfileK300AyModule,
	ProfileK300Effect,
	PushEffect,
	RdvCbaEffect,
	RdvPersoEffect,
	reducers,
	ReglementEffect,
	RejetEffect,
	RemplacantEffect,
	RemplacantSituationEffect,
	ScorEffect,
	ScorModule,
	SeanceEffect,
	selectFullClient,
	selectFullCLientLoading,
	SmallSpinnerDialogModule,
	STARTUP_SERVICE_TOKEN,
	SupportDroitsDataEffect,
	SvgDefinitionAyModule,
	SvgDefinitionModule,
	TacheDocumentPatientEffect,
	TacheQuestionEffect,
	TeletransmissionEffect,
	ThemeService,
	ToastrAyModule,
	TourneeEffect,
	TraitementEffect,
	TransmissionCabinetEffect,
	TransmissionPatientEffect,
	TriEffect,
	UserMyinfiAyEffect,
	WorkeuseSpinnerDialogModule,
} from "features";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";

import { AppAyComponent } from "./app-ay.component";
import { AppAyRoutingModule } from "./app-ay-routing.module";
import { EffectsModule } from "@ngrx/effects";
import { Store, StoreModule } from "@ngrx/store";

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicStorageModule } from "@ionic/storage-angular";
import { Drivers } from "@ionic/storage";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule, DatePipe, registerLocaleData } from "@angular/common";
// tslint:disable-next-line:import-name
import localeFr from "@angular/common/locales/fr";
import * as Sentry from "@sentry/angular";
import { AuthAyEffect } from "./core/auth/effects/auth-ay.effect";
import { environment } from "@env/environment";
import {
	APP_INITIALIZER,
	computed,
	ErrorHandler,
	inject,
	Injector,
	LOCALE_ID,
	NgModule,
	provideEnvironmentInitializer,
} from "@angular/core";
import { StartupService } from "@services/startup.service";
import { AgatheYouCareService } from "@services/agathe-you-care.service";
import { MatDialogModule } from "@angular/material/dialog";
import { AuthInterceptor } from "./core/auth/interceptor/auth.interceptor";
import { EntenteDialogService } from "@featuresAY/ordonnance-web-ay/services/entente-dialog.service";
import { LECTEUR_DIALOG } from "@jack-sparrow-libraries/lib-agathe-link";
import { LecteurDialogService } from "@featuresAY/lecteur/services/lecteur-dialog.service";
import { LecteurEffect } from "@featuresAY/lecteur/store/lecteur/lecteur.effect";
import { lecteurReducer } from "@featuresAY/lecteur/store/lecteur/lecteur.reducer";
import { PatientModalAyServiceImpl } from "@featuresAY/patient-web-ay/services/patient-modal-ay.service";
import { DocumentEffect } from "./core/store/document/document.effect";
import { ImageViewerWebModule } from "@shared-ay/image-viewer-web/image-viewer-web.module";
import { UiKitModule, UiKitThemeService } from "@jack-sparrow-libraries/ui-kit";
import { MatIconModule } from "@angular/material/icon";
import { OrdonnanceDetailsEffects } from "@featuresAY/ordonnance-web-ay/store/details-ordonnance/ordonnance-details.effects";
import { ordonnanceDetailsReducer } from "@featuresAY/ordonnance-web-ay/store/details-ordonnance/ordonnance-details.reducer";
import { AlertAyWebModule } from "@shared-ay/alert-ay-web/alert-ay-web.module";
import { LoadingAyWebService } from "@services/loading-ay-web.service";
import { SpinnerLoadingAyWebModule } from "@shared-ay/spinner-loading-ay-web/spinner-loading-ay-web.module";
import { LayoutAyWebModule } from "@shared-ay/layouts/layout-ay-web.module";
import { InputMaskModule } from "@ngneat/input-mask";
import { communicationReducer } from "./core/store/communication/communication.reducer";
import { CommunicationEffect } from "./core/store/communication/communication.effect";
import { ModifMutuellePatientEffect } from "@featuresAY/mutuelle-web-ay/store/modif-mutuelle-patient.effect";
import { SliderWebAyModule } from "@shared-ay/slider-web-ay/slider-web-ay.module";

import { OrdonnanceCreationEffect } from "@featuresAY/ordonnance-web-ay/store/ordonnance/ordonnance-creation.effect";
import { ordonnanceCreationReducer } from "@featuresAY/ordonnance-web-ay/store/ordonnance/ordonnance-creation.reducer";

import { MutuelleAlertAyWebService } from "@featuresAY/mutuelle-web-ay/services/mutuelle-alert-ay-web.service";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { SCOR_LOADING_SERVICE, UploadScorModule } from "@jack-sparrow-libraries/upload-scor";
import { provideFactureElectronique } from "@jack-sparrow-libraries/facture-electronique";
import { ROLE_EFACTURES } from "@enums/role-e-factures.constant";
import { EfactureRetourService } from "@services/efacture-retour.service";
import { OrdonnanceScorService } from "@featuresAY/ordonnance-web-ay/services/ordonnance-scor.service";
import { traitementReducer } from "@featuresAY/ordonnance-web-ay/store/traitement/traitement.reducer";
import { TraitementV2Effects } from "@featuresAY/ordonnance-web-ay/store/traitement/traitement.effects";
import { LecteurModule } from "@featuresAY/lecteur/lecteur.module";
import { patientAbsenceReducer } from "@featuresAY/patient-web-ay/store/patient-absence/patient-absence.reducer";
import { PatientAbsenceEffects } from "@featuresAY/patient-web-ay/store/patient-absence/patient-absence.effects";
import { CustomAlertService } from "@services/custom-alert.service";
import { initializePostHog, PosthogService } from "@services/posthog.service";
import { AngularBusinessCoordinationModule } from "@jack-sparrow-libraries/angular-business-coordination";
import { PreferencesService } from "@services/preferences.service";
import {
	ANGULAR_COMMONS_CONFIGURATION,
	COMMONS_ALERT_HANDLING_SERVICE,
	COMMONS_PREFERENCES_DATA_SOURCE,
	provideInitAngularCommons,
} from "@jack-sparrow-libraries/angular-business-commons";
import { CommonsConfigurationAgatheyouService } from "@services/services-lib-abc/commons-configuration-agatheyou.service";
import { provideCommonsImagesDataSource } from "@services/services-lib-abc/images-source.service";
import { provideCommonsNavigationService } from "@services/services-lib-abc/commons-navigation.service";
import { ToasterService } from "@services/services-lib-abc/toaster.service";
import { AppLayoutComponent } from "@core/layout/layout.component";

registerLocaleData(localeFr);

@NgModule({
	declarations: [AppAyComponent],
	bootstrap: [AppAyComponent],
	imports: [
		UploadScorModule.forRoot(environment.dwProductKey),
		IonicStorageModule.forRoot({
			name: "__mydb",
			driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
		}),
		StoreModule.forRoot(
			{
				...reducers,
				lecteur: lecteurReducer,
				ordonnanceDtails: ordonnanceDetailsReducer,
				communication: communicationReducer,
				ordonnanceCreation: ordonnanceCreationReducer,
				traitementV2: traitementReducer,
				patientAbsence: patientAbsenceReducer,
			},
			{ metaReducers },
		),
		AngularBusinessCoordinationModule.forRoot({
			backendUrl: environment.apiEmotion(),
			enableReduxDevtool: false,
		}),
		StoreDevtoolsModule.instrument({
			maxAge: 80, // Retains last 25 states
			logOnly: environment.production, // Restrict extension to log-only mode
			predicate: (state, action) => {
				// Return false for actions you don't want to track
				return !action.type.includes("[COMMAND_MOBILE]") && !action.type.includes("[ACTION_STACK]");
			},
		}),
		BrowserModule,
		BrowserAnimationsModule,
		HammerModule,
		CommonModule,
		AppAyRoutingModule,
		IonicModule.forRoot({ swipeBackEnabled: false }),
		MatDialogModule,
		IdelRemplacantModule,
		FormsModule,
		ReactiveFormsModule,
		ProfileK300AyModule,
		SvgDefinitionModule,
		SvgDefinitionAyModule,
		ScorModule,
		AlertParamEnCoursModule,
		ToastrAyModule,
		WorkeuseSpinnerDialogModule,
		SmallSpinnerDialogModule,
		AlertAyModule,
		MatIconModule,
		UiKitModule,
		FacturationModule,
		EffectsModule.forRoot([
			PersistentStoreEffect,
			LoggerEffect,
			CommandMobileEffect,
			AuthEffect,
			AuthAyEffect,
			MobileJourFeriePersoEffect,
			MobilePatientEffect,
			PatientEffect,
			ModifMutuellePatientEffect,
			ActionStackEffect,
			NotificationPsEffect,
			TransmissionCabinetEffect,
			TransmissionPatientEffect,
			CabinetEffect,
			IdelEffect,
			PushEffect,
			ApplicationEffect,
			MobileAntecedentEffect,
			AnalyseEffect,
			CaisseEffect,
			CampagneMyinfiAyEffect,
			UserMyinfiAyEffect,
			CampagneMyinfiCallbackAyEffect,
			ConstanteVitaleEffect,
			DiagrammeSoinsEffect,
			DiagrammeSoinsCategorieEffect,
			DiagrammeSoinsCategoriePersoEffect,
			DiagrammeSoinsValeurEffect,
			MobileDocumentPatientEffect,
			MobileAbsencePatientEffect,
			EntenteEffect,
			IdelExecutantEffect,
			IdelRemplacantEffect,
			LaboratoireEffect,
			MobileOrdonnanceEffect,
			OrdonnancePartielleEffect,
			OrdonnanceEffect,
			ParametresEffect,
			MobilePraticienEffect,
			FiltreEffect,
			OrdonnanceBrouillonEffect,
			MobilePreferenceEffect,
			PrelevementEffect,
			PrelevementResultatEffect,
			RemplacantSituationEffect,
			ClientEffects,
			SeanceEffect,
			MobileRdvPersoEffect,
			MobileRdvMyInfiEffect,
			TourneeEffect,
			TraitementEffect,
			ScorEffect,
			NomenclatureEffect,
			MobileMutuelleEffect,
			NotificationPsEffect,
			MutuelleEffect,
			ProfileK300Effect,
			FacturationEffect,
			DiagnosticStsEffect,
			TeletransmissionEffect,
			LotEffect,
			MobileLotEffect,
			FichierEffect,
			PlanningEffect,
			PlanningMyInfiEffect,
			FactureEffect,
			DocumentPatientEffect,
			RemplacantEffect,
			ReglementEffect,
			AntecedentEffect,
			RdvPersoEffect,
			MobileServiceCbaEffect,
			MobileIdeeEffect,
			TacheDocumentPatientEffect,
			TacheQuestionEffect,
			MobileServiceClientEffect,
			HostEffect,
			MobileDmpEffect,
			MobileDmpToDoFromMobileEffect,
			DispatchatorEffect,
			MobileFactureEffect,
			MobileReglementEffect,
			NavigationEffect,
			ConsentementHdsEffect,
			SupportDroitsDataEffect,
			MobileAbsencePatientEffect,
			MobilePlanningEffect,
			MobilePlanningMyInfiEffect,
			AdriEffect,
			OrdonnanceScorEffect,
			CentresSesamEffect,
			DocumentOcrEffect,
			EntenteEffect,
			RdvCbaEffect,
			RejetEffect,
			TriEffect,
			LecteurEffect,
			DocumentEffect,
			PraticienEffect,
			OrdonnanceDetailsEffects,
			CommunicationEffect,
			OrdonnanceCreationEffect,
			TraitementV2Effects,
			PatientAbsenceEffects,
		]),
		FeaturesModule.forRoot(environment),
		FacturationModule,
		BrowserModule,
		BrowserAnimationsModule,
		HammerModule,
		CommonModule,
		AppAyRoutingModule,
		IonicModule.forRoot({ swipeBackEnabled: false }),
		IdelRemplacantModule,
		FormsModule,
		ReactiveFormsModule,
		ProfileK300AyModule,
		SvgDefinitionModule,
		SvgDefinitionAyModule,
		ScorModule,
		AlertParamEnCoursModule,
		ToastrAyModule,
		WorkeuseSpinnerDialogModule,
		SmallSpinnerDialogModule,
		AlertAyModule,
		MatDialogModule,
		UiKitModule.forRoot({
			errors: [
				{
					error: "invalidComptage",
					errorLabel: "Comptage invalide",
				},
			],
		}),
		ImageViewerWebModule,
		AlertAyWebModule,
		SpinnerLoadingAyWebModule,
		LayoutAyWebModule,
		InputMaskModule,
		SliderWebAyModule,
		LecteurModule,
		AppLayoutComponent,
	],
	providers: [
		{ provide: COMMONS_PREFERENCES_DATA_SOURCE, useExisting: PreferencesService },
		provideInitAngularCommons(),
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => {},
			deps: [Sentry.TraceService],
			multi: true,
		},
		{
			provide: APP_INITIALIZER,
			useFactory: initializePostHog,
			deps: [PosthogService],
			multi: true,
		},
		DatePipe,
		{
			provide: LECTEUR_DIALOG,
			useExisting: LecteurDialogService,
		},
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		{ provide: CustomLoadingAyService, useClass: LoadingAyWebService },
		{ provide: AlertService, useClass: CustomAlertService },
		{ provide: LOCALE_ID, useValue: "fr-FR" },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true },
		{
			provide: STARTUP_SERVICE_TOKEN,
			useExisting: StartupService,
		},
		{
			provide: ENTENTE_DIALOG_TOKEN,
			useExisting: EntenteDialogService,
		},
		{
			provide: MUTUELLE_ALERT_SERVICE_TOKEN,
			useExisting: MutuelleAlertAyWebService,
		},
		{
			provide: PATIENT_MODAL_SERVICE_TOKEN,
			useExisting: PatientModalAyServiceImpl,
		},
		{
			provide: SCOR_LOADING_SERVICE,
			useExisting: OrdonnanceScorService,
		},
		provideHttpClient(withInterceptorsFromDi()),
		provideFactureElectronique(() => {
			// Injector et pas EfactureRetourService directement : ce service depend de
			// EfactureAuthService, qui depend du token de config en cours de construction
			// ici (dependance circulaire). On le resout au premier 401, pas avant.
			const injector = inject(Injector);
			const store = inject(Store<AppState>);
			const fullClient = store.selectSignal(selectFullClient);
			const droitsEnChargement = store.selectSignal(selectFullCLientLoading);
			return {
				apiBaseUrl: environment.factureElectronique.apiBaseUrl,
				clientType: environment.factureElectronique.clientType,
				espaceClientActivationUrl: environment.factureElectronique.espaceClientActivationUrl,
				onUnauthorized: () => injector.get(EfactureRetourService).demarrerLogin(),
				// L'option se lit sur les roles SSO (`SsoApiAyService.getSsoClientRoles`, agreges
				// dans `FullClient.roles`) : c'est le SSO qui arbitre l'acces au back efacture.
				// Sans le role, la lib rend l'ecran de souscription et n'appelle PAS ce back —
				// sinon son 401 declenche un login SSO qui ejecte l'utilisateur de l'application.
				//
				// `undefined` tant que le client complet charge : sans ce troisieme etat, l'ecran
				// de vente clignoterait devant un client qui a pourtant le role. `fullClientLoading`
				// retombe a `false` en succes COMME en erreur — pas de loader infini.
				optionSouscrite: computed(() =>
					droitsEnChargement() ? undefined : (fullClient()?.roles ?? []).includes(ROLE_EFACTURES),
				),
			};
		}),
		{ provide: COMMONS_ALERT_HANDLING_SERVICE, useExisting: ToasterService },
		{ provide: ANGULAR_COMMONS_CONFIGURATION, useClass: CommonsConfigurationAgatheyouService },

		provideCommonsImagesDataSource(),
		provideCommonsNavigationService(),
		// Instancié au démarrage pour son seul effet sur la page hôte : favicon Care et classe .ay-care des loaders Struts.
		provideEnvironmentInitializer(() => inject(AgatheYouCareService)),
	],
})
export class AppAyModule {
	// ⚠ NE PAS SUPPRIMER : aucune API de ces deux services n'est consommée ici, ils sont instanciés
	// au bootstrap pour leur seul effet de bord sur le DOM.
	// - UiKitThemeService pose la typographie (.theme-ay) sur <html> et <body>.
	// - ThemeService pose la palette par défaut (.theme-ay-feel-good) sur <body> : sans elle aucune
	//   variable --uikit-palette-* n'est résolue et l'application entière démarre sans couleurs.
	private readonly uiKitThemeService = inject(UiKitThemeService);
	private readonly themeService = inject(ThemeService);
}
